import script from "./transactionDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./transactionDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./transactionDetailsPopup.vue?vue&type=style&index=0&id=05023533&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05023533"]])

export default __exports__